import React from "react";
import { Link } from "react-router-dom";

import { useTheme, styled } from "@mui/material/styles";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import Translations from "layouts/components/Translations";
import UserIcon from "layouts/components/UserIcon";
import themeConfig from "configs/themeConfig";

const MenuNavLink = styled(ListItemButton)(({ theme }) => ({
  borderRadius: 8,
  marginLeft: "10px",
  marginRight: "10px",
  marginTop: "5px",
  marginBottom: "5px",
  flexDirection: "row",
  alignItems: "center",
  listStyle: "none",
  padding: "10px",
  textDecoration: "none",
  transition: "padding .25s ease-in-out",
  "&.active": {
    "&, &:hover": {
      backgroundColor: theme.palette.primary.light,
    },
    "& .MuiTypography-root": {
      fontWeight: 500,
      color: `${theme.palette.common.white} !important`,
    },
    "& .MuiListItemIcon-root": {
      color: `${theme.palette.common.white} !important`,
    },
  },
}));

const MenuItemTextMetaWrapper = styled(Box)({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  transition: "opacity .25s ease-in-out",
  ...(themeConfig.menuTextTruncate && { overflow: "hidden" }),
});

const SubMenuItems = (props) => {
  const {
    index,
    items,
    location,
    navCollapsed,
    navHover,
    skin,
    navVisible,
    toggleNavVisibility,
  } = props;

  const theme = useTheme();

  const isNavLinkActive1 = () => {
    if (location.pathname === items.path) {
      return true;
    } else {
      return false;
    }
  };

  const conditionalIconColor = () => {
    if (skin === "semi-dark" && theme.palette.mode === "light") {
      return {
        color: `rgba(${theme.palette.customColors.dark}, ${0.87})`,
      };
    } else if (skin === "semi-dark" && theme.palette.mode === "dark") {
      return {
        color: `rgba(${theme.palette.customColors.light}, ${0.87})`,
      };
    } else
      return {
        color: items.children
          ? theme.palette.text.secondary
          : theme.palette.text.primary,
      };
  };

  return (
    <Link
      key={`sub_${index}`}
      to={items.path === undefined ? "/" : `${items.path}`}
      style={{ textDecoration: "none" }}
    >
      {(navCollapsed && navHover) || !navCollapsed ? (
        <MenuNavLink
          key={`sub_${index}`}
          className={isNavLinkActive1(items) ? "active" : ""}
          sx={{
            mt: 1.5,
            flexDirection: "row",
            transition: "padding .25s ease-in-out",
            color:
              items.path === location.pathname
                ? `${theme.palette.common.white} !important`
                : `${theme.palette.secondary.main} !important`,
          }}
          onClick={() => {
            if (navVisible) {
              toggleNavVisibility();
            }
          }}
        >
          <ListItemIcon
            sx={{
              py: 0,
              pl: 4,
              ...conditionalIconColor(),
              transition: "margin .25s ease-in-out",
              ...(navCollapsed && !navHover ? {} : { mr: 2 }),
              ...(navCollapsed && !navHover ? { mr: 0 } : {}),
            }}
          >
            <UserIcon
              icon={themeConfig.navSubItemIcon}
              componentType="vertical-menu"
              iconProps={{ sx: { ...{ fontSize: "0.5rem" } } }}
            />
          </ListItemIcon>

          <MenuItemTextMetaWrapper
            sx={{
              ...(navCollapsed && !navHover ? { opacity: 0 } : { opacity: 1 }),
            }}
          >
            <Typography
              {...((themeConfig.menuTextTruncate ||
                (!themeConfig.menuTextTruncate && navCollapsed)) && {
                noWrap: true,
                marginLeft: "10px",
                fontSize: "16px",
                letterSpacing: "0.3px",
              })}
            >
              <Translations text={items.title} />
            </Typography>
          </MenuItemTextMetaWrapper>
        </MenuNavLink>
      ) : null}
    </Link>
  );
};

export default SubMenuItems;
